export default "__VITE_ASSET__Cq3EUGy9__"